import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions as UnstyledDialogActions,
  DialogContent as UnstyledDialogContent,
  DialogContentText as UnstyledDialogContentText,
  DialogTitle as UnstyledDialogTitle,
} from "@material-ui/core";
import { PrimaryButton as UnstyledPrimaryButton, SecondaryButton as UnstyledSecondaryButton } from "components/Global/Buttons";
import { InputText as UnstyledInputText } from "@loanbossinc/component-library";
import styled from "styled-components";

const DialogTitle = styled(UnstyledDialogTitle)`
  && {
    padding-left: 32px;
    padding-right: 32px;

    h2 {
      color: #0e3f62;
      font-size: 20px;
    }
  }
`;

const DialogContent = styled(UnstyledDialogContent)`
  && {
    padding-left: 32px;
    padding-right: 32px;
  }
`;


const DialogContentText = styled(UnstyledDialogContentText)`
  && {
    color: #0e3f62;
    font-size: 16px;
  }
`;

const InputText = styled(UnstyledInputText)`
  && {
    margin-top: 20px;

    & > div {
      &::before {
        border-bottom-color: #B3C2CC;
      }

      &::after,
      &:hover::before {
        border-bottom-color: #1979BD !important;
      }
    }
    
    input {
      color: #0e3f62;

      &::placeholder {
        opacity: 0.75;
      }
    }
  }
`;

const DialogActions = styled(UnstyledDialogActions)`
  && {
    margin: 0 32px 24px 32px;
  }
`;

const PrimaryButton = styled(UnstyledPrimaryButton)`
  &&& {
    background: #1979BD;
    color: white;
    border-radius: 8px;
    padding: 8px 24px;
    border-width: 0 0 1.5px 0;
    border-style: solid;
    border-color: #12588A;
    margin: 0;
    text-transform: none;

    &:disabled {
      background: #A9B1B5;
      border-color: #B3C2CC;
      color: white;
    }
  }
`;

const SecondaryButton = styled(UnstyledSecondaryButton)`
  &&& {
    background: white;
    color: #1979BD;
    border-radius: 8px;
    padding: 8px 24px;
    border-width: 1px 1px 1.5px 1px;
    border-style: solid;
    border-color: #B3C2CC;
    margin: 0 20px 0 0;
    text-transform: none;
  }
`;

const validConfirmInputValue = "DELETE";

const DeleteReportInstanceDialog = ({ modalOpen, handleCancel, handleConfirm }) => {
  const [confirmInputValue, setConfirmInputValue] = useState("");
  const [confirmationInProgress, setConfirmationInProgress] = useState(false);

  useEffect(() => {
    if (modalOpen) {
      setConfirmInputValue("");
    }
  }, [modalOpen]);

  const handleConfirmInputChange = (event) => {
    setConfirmInputValue(event.currentTarget.value.toUpperCase());
  };

  const handleConfirmBtnClick = async () => {
    setConfirmationInProgress(true);
    await handleConfirm();
    setConfirmationInProgress(false);
  };

  const isConfirmBtnDisabled = validConfirmInputValue !== confirmInputValue || confirmationInProgress;

  return (
    <Dialog
      fullWidth
      open={modalOpen}
      onClose={handleCancel}
      PaperProps={{
        style: {
          borderRadius: "12px",
          width: "540px",
        },
      }}
    >
      <DialogTitle>Delete report packet</DialogTitle>
      <DialogContent>
        <DialogContentText>Deleting this report packet cannot be undone, are you sure you want to continue?</DialogContentText>
        <InputText type="text" placeholder={`Confirm by typing “${validConfirmInputValue}”`} fullWidth variant="standard" onChange={handleConfirmInputChange} value={confirmInputValue} autoFocus />
      </DialogContent>
      <DialogActions>
        <SecondaryButton type="button" onClick={handleCancel}>
          Cancel
        </SecondaryButton>
        <PrimaryButton type="button" onClick={handleConfirmBtnClick} disabled={isConfirmBtnDisabled}>
          Ok
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteReportInstanceDialog;
